const RoutesConst = {
    Home: `/`,
    Login: `/login`,
    Register: `/register`,
    ForgotPassword: `/account/forgot-password`,
    ResetPassword: `/account/reset-password`,
    VerifyAccountMail: `/account/verify-activation-mail`,
    EWallet: `/e-wallet`,
    PaymentInfo: `/payment-info`,
    SellingSpots: `/selling-spots`,
    BusLines: `/bus-lines`,
    RouteCalculation: `/route-calculation`,
    FrequentylAskedQuestions: `/frequently-asked-questions`,
    TermsOfUse: `/terms-of-use`,
    Contact: `/contact`,
    MyProfile: `/my-profile`,
    MyTransactions: `/my-transactions`,
    MyCoupons: `/my-coupons`,
    ActivateFullProfile: `/activate-full-profile`,
    Dashboard: `/dashboard`,
    PenaltyPay: `/penalty-pay`
}

export default RoutesConst;
